const DEFAULT_VALUE = '-';

/**
 * Returns the value when non-empty, otherwise the placeholder "-".
 *
 * Shared by the payment history table, the mobile list and the detail sheet so empty
 * cells render the same fallback character across breakpoints.
 *
 * @param value - Raw payment field value
 * @returns The value or the default placeholder when empty
 */
export const displayPaymentValue = (value: string): string => value || DEFAULT_VALUE;
